export default "__VITE_ASSET__DVkCJuOQ__"